﻿$.fn.dxCtrlWidgetNumber = function custom_dxCtrlWidgetNumber(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlwidgetnumber dx-ctrl");
        this.createInstance(new cdxCtrlWidgetNumber(this, option));
    }
    return this;
}

window.cdxCtrlWidgetNumber = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
        var dxNum = $("<div/>").appendTo(container).dxCtrlNumberBox({
            label: option.label,
            labelMode: 'floating',
            placeholder: option.placeholder,
            min: 0,
            noNull:option.noNull,
            value: option.value,
            onValueChanged: option.onValueChanged,
            buttons: [{
                focusStateEnabled: false,
                name: 'pre',
                location: 'before',
                options: {
                    icon: 'spinprev',
                    stylingMode: 'text',
                    onClick() {
                        if (dxNum.option("value") == null) { dxNum.option("value", 0) }
                        else {
                            if (dxNum.option("value") > 0) dxNum.option("value", dxNum.option("value") - 1)
                        }
                    },
                },
            }, {
                focusStateEnabled: false,
                name: 'next',
                location: 'after',
                options: {
                    icon: 'spinnext',
                    stylingMode: 'text',
                    onClick() {
                        if (dxNum.option("value") == null) { dxNum.option("value", 1) }
                        else {
                            dxNum.option("value", dxNum.option("value") + 1)
                        }
                    },
                },
                }],
            onContentReady: function (e) {
                e.component.element().find("input").css({
                    "text-align": "center",
                    "padding-left": "0px",
                    "padding-right": "0px"
                })
                resizeObserver.mAdd(e.component.element(), function () {
                    e.component.element().find(".dx-label").css("max-width", "85%")
                })
            }
        }).dxCtrlNumberBox("instance")
    }

    this.element = function () { return container }

    mConstruit();
}